var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "junction-box-utilization-table" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("h3", { staticClass: "mb-2" }, [
          _vm._v("JB Terminal Connection Calculation"),
        ]),
        _c(
          "base-btn",
          { attrs: { disabled: _vm.loading }, on: { click: _vm.fetchData } },
          [
            _c("v-icon", { staticClass: "mr-1" }, [_vm._v("mdi-refresh")]),
            _vm._v(" " + _vm._s(_vm.loading ? "Reloading…" : "Reload") + " "),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "relative overflow-auto pb-5" }, [
      _c("table", { staticClass: "foex-table" }, [
        _vm._m(0),
        _c(
          "tbody",
          [
            _vm._l(_vm.rows, function (row) {
              return _c("tr", { key: row.id }, [
                _c("td", [_vm._v(_vm._s(row.crossSection))]),
                _c("td", [_vm._v(_vm._s(row.ratedCurrent))]),
                _c("td", [_vm._v(_vm._s(row.quantity))]),
                _c("td", [_vm._v(_vm._s(row.quantityMax))]),
                _c("td", { class: _vm.utilClass(row.utilizationPercent) }, [
                  _vm._v(_vm._s(_vm.formatPercent(row.utilizationPercent))),
                ]),
              ])
            }),
            !_vm.loading && !_vm.rows.length
              ? _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center py-3",
                      attrs: { colspan: "5" },
                    },
                    [_vm._v("No data")]
                  ),
                ])
              : _vm._e(),
            _vm.loading
              ? _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "text-center py-3",
                      attrs: { colspan: "5" },
                    },
                    [_vm._v("Loading...")]
                  ),
                ])
              : _vm._e(),
            _vm.rows.length && !_vm.loading
              ? _c("tr", { staticClass: "total-row" }, [
                  _c(
                    "td",
                    {
                      staticClass: "text-right pr-4 font-weight-bold",
                      attrs: { colspan: "4" },
                    },
                    [_vm._v("Total Utilization")]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "font-weight-bold",
                      class: _vm.utilClass(_vm.totalUtilizationPercent),
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.formatPercent(_vm.totalUtilizationPercent))
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cross-Section (mm2)")]),
        _c("th", [_vm._v("Rated Current(A)")]),
        _c("th", [_vm._v("Quantity")]),
        _c("th", [_vm._v("Quantity Max.")]),
        _c("th", [_vm._v("Utilization (%)")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }